module.exports = __webpack_public_path__ + "img/102.76410523.png";